import React from 'react';
import { MenuOutlined } from '@ant-design/icons';

interface PickUpMenuIconWithBadgeProps {
    count: number; // 动态数字
}

const WayPointMenuIconWithBadge: React.FC<PickUpMenuIconWithBadgeProps> = ({ count }) => {
    return (
        <div className="relative">
            <MenuOutlined />
            {count > 0 && (
                <span
                    className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs"
                >
                    {count > 99 ? '99+' : count}
                </span>
            )}
        </div>
    );
};

export default WayPointMenuIconWithBadge;
